export default __webpack_public_path__ + "static/media/Stats_API.a0cb86f4.svg";